import React from 'react';
import { baseXUnit, breakpoints, color } from '../../styles/theme';
import IconText from '../common/IconText';
import { IconName } from '../common/Icon';
import H from '../elements/H';
import Spacing from '../common/Spacing';

interface DestinationFactBoxProps {
  label: string;
  icon: IconName;
  content: string;
}
const DestinationFactBox: React.FunctionComponent<DestinationFactBoxProps> = ({
  label,
  icon,
  content
}) => {
  return (
    <div className="root">
      <Spacing top={[0, 0, 1]}>
        <div className="label">
          <Spacing left={4}>
            <H
              tag="div"
              styling="h5"
              color="gray"
              data-testid="destination-data-label"
            >
              {label}
            </H>
          </Spacing>
        </div>
      </Spacing>
      <IconText icon={icon} iconSize={3} iconColor="gray">
        <H styling="h4" tag="div" data>
          {content}
        </H>
      </IconText>
      {/*language=CSS*/}
      <style jsx>{`
        .root {
          border-top: solid 1px ${color.light};
          padding-bottom: ${baseXUnit(1.5)};
        }
        .label {
          padding-top: ${baseXUnit(1)};
        }

        @media ${breakpoints.large} {
          .root {
            border-top: none;
          }
        }
      `}</style>
    </div>
  );
};

export default DestinationFactBox;
